import React from 'react';
import { LinearProgress } from 'rmwc/LinearProgress';
import { Text } from '../../components/Text';

export const LoadingBar = () => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '400px',
    }}
  >
    <Text use="body1">Loading...</Text>
    <LinearProgress determinate={false} style={{ width: '20%', minWidth: '100px' }} />
  </div>
);
